import React from "react";
import { render } from "react-dom";
import GamesFilterHead from "../components/GamesFilterHead.jsx";
import page from "page";
import gameFilter from "../helpers/gameFilter";
import PlayVideo from "../helpers/PlayVideo";
import moverAddHome from "../helpers/moverAddHome";
import noUnityChrome from "../helpers/noUnityChrome";
import footerHome from "../helpers/footerHome";
function homepage() {
	// Filtrado de Juegos
	render(<GamesFilterHead />, document.getElementById("GamesFilterHead"));
	// render(<GamesFilterNavigation page={paginationData.page} totalPages={paginationData.totalPages} />, document.getElementById('GamesFilterNavigation'));

	page("/:page", gameFilter);
	page("/", gameFilter);
	page();

	noUnityChrome();
	new PlayVideo();
	footerHome();

	if (document.visibilityState == "prerender") {
		$("html, body").scrollTop(0);
	}
}
export default homepage;
